@if (header() && options().timeFilterable && options().timeFilter) {
  <button
    mat-icon-button
    collapsibleButton
    tooltip-position="below"
    matTooltipShowDelay="500"
    [matTooltip]="'igo.geo.filter.filterBy' | translate"
    [color]="color()"
  >
    <mat-icon
      aria-hidden="false"
      [matBadge]="badge"
      matBadgeColor="accent"
      matBadgeSize="medium"
      >history</mat-icon
    >
  </button>
}

@if (header() && options().timeFilterable && options().timeFilter) {
  <div #ogcFilter class="igo-layer-actions-container">
    @if (timeFilterCollapse && options().timeFilter) {
      <igo-time-filter-item igoListItem [header]="false" [layer]="layer()" />
    }
  </div>
}
